<template>
  <div
    class="char-container" :style="{width: getMonogramBoxSize().width * (getDpi() / 254.0) + 'px', height: getMonogramBoxSize().height * (getDpi() / 254.0) + 'px'}">
   <div class="char-layer">
      <DSTPreview
        :dwidth="store.allFonts.value[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelWidth * (getDpi() / 254.0)"
        :dheight="store.allFonts.value[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelHeight * (getDpi() / 254.0)"
        :dstFile="store.allFonts.value[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile"
        :layersColors="colorLeftChar"
        :left="getLeft(1)"
        :top="getTop('left')"
      >
      </DSTPreview>
    </div>
     <div v-if="monogramObj.numOfCharacters != '2' && this.char2"
      class="char-layer">
      <DSTPreview
        :dwidth="store.allFonts.value[this.monogramObj.middleChar.fontID].sizes[
            this.monogramObj.middleChar.fontSizeID
            ].DictCharacters[this.char2].dstfile.pixelWidth * (getDpi() / 254.0)"
        :dheight="store.allFonts.value[this.monogramObj.middleChar.fontID].sizes[
            this.monogramObj.middleChar.fontSizeID
            ].DictCharacters[this.char2].dstfile.pixelHeight * (getDpi() / 254.0)"
        :dstFile="store.allFonts.value[this.monogramObj.middleChar.fontID].sizes[
            this.monogramObj.middleChar.fontSizeID
            ].DictCharacters[this.char2].dstfile"
        :layersColors="colorMiddleChar"
        :left="getLeft(2)"
        :top="getTop('middle')"
      >
      </DSTPreview>
    </div>
    <div class="char-layer">
      <DSTPreview
        :dwidth="store.allFonts.value[this.monogramObj.rightChar.fontID].sizes[
          this.monogramObj.rightChar.fontSizeID
        ].DictCharacters[this.char3].dstfile.pixelWidth * (getDpi() / 254.0)"
        :dheight="store.allFonts.value[this.monogramObj.rightChar.fontID].sizes[
          this.monogramObj.rightChar.fontSizeID
        ].DictCharacters[this.char3].dstfile.pixelHeight * (getDpi() / 254.0)"
        :dstFile="store.allFonts.value[this.monogramObj.rightChar.fontID].sizes[
          this.monogramObj.rightChar.fontSizeID
        ].DictCharacters[this.char3].dstfile"
        :layersColors="colorRightChar"
        :left="getLeft(3)"
        :top="getTop('right')"
      >
      </DSTPreview>
    </div>
  </div>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import DSTPreview from "./DSTPreview.vue";

export default {
  setup() {
    const store = designerStore();
    const allFonts = store.getAllFontsToMonogramDict();
    return {
      store,
      allFonts,
    };
  },
  data() {
    return {
      // dpi: 254.0,
    }
  },
  components: {
    DSTPreview,
  },
  props: [
    "monogramObj",
    "char1",
    "char2",
    "char3",
    "colorLeftChar",
    "colorMiddleChar",
    "colorRightChar",
    "align",
    "distance1",
    "distance2",
    "dpi",
    "left",
    "top",
    "dw",
    "dh"
  ],

  methods: {
    getLeft(index) {
      if (index == 1) {
        return (parseFloat(this.left ? this.left : 0));
        //אם המונוגרם זו האות השניה או האחרונה במונוגרם של 2 אותיות
        } else if (index == 2 || (index == 3 && this.monogramObj.middleChar == null)) {
        //אם הוא באות השניה עכשיו - לוקח את רוחב האות הראשונה והרווח ביניהם
        return (
          ((this.allFonts[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelWidth + parseFloat(this.distance1)) * (this.getDpi() / 254.0)) + (parseFloat(this.left ? this.left : 0))
        );
      } else if (index == 3) {
        //אם הוא באות השלישית - בודק האם היו 2 או 3 אותיות לפני שמחשב
        if (this.allFonts[this.monogramObj.middleChar.fontID].sizes[
          this.monogramObj.middleChar.fontSizeID
        ].DictCharacters[this.char2] != null) {
          //אם בטוח זה 3 אותיות
          return (
            ((this.allFonts[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelWidth + parseFloat(this.distance1) + 
            this.allFonts[this.monogramObj.middleChar.fontID].sizes[
          this.monogramObj.middleChar.fontSizeID
        ].DictCharacters[this.char2].dstfile.pixelWidth + parseFloat(this.distance2)) * (this.getDpi() / 254.0)) + (parseFloat(this.left ? this.left : 0)));
          
        } else {
          // אחרת - יש רק 2 אותיות
          return (
            ((this.allFonts[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelWidth + parseFloat(this.distance1)) * (this.getDpi() / 254.0)) + (parseFloat(this.left ? this.left : 0))
          );
        }
      }
    },
    getTop(char) {
      if (this.align == "top") {
        return (parseFloat(this.top ? this.top : 0));
      } else if (this.align == "center") {
        return (
          ((this.store.getMaxMonogramHeight(this.monogramObj, this.char1, this.char2, this.char3) / 2 -
            (char == "left"
              ? this.allFonts[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelHeight
              : char == "right"
              ? this.allFonts[this.monogramObj.rightChar.fontID].sizes[
          this.monogramObj.rightChar.fontSizeID
        ].DictCharacters[this.char3].dstfile.pixelHeight
              : this.allFonts[this.monogramObj.middleChar.fontID].sizes[
          this.monogramObj.middleChar.fontSizeID
        ].DictCharacters[this.char2].dstfile.pixelHeight) /
              2) *
          (this.getDpi() / 254.0)) + (parseFloat(this.top ? this.top : 0))
        );
      } else {
        return (
          ((this.store.getMaxMonogramHeight(this.monogramObj, this.char1, this.char2, this.char3) -
            (char == "left"
              ? this.allFonts[this.monogramObj.leftChar.fontID].sizes[
          this.monogramObj.leftChar.fontSizeID
        ].DictCharacters[this.char1].dstfile.pixelHeight
              : char == "right"
              ? this.allFonts[this.monogramObj.rightChar.fontID].sizes[
          this.monogramObj.rightChar.fontSizeID
        ].DictCharacters[this.char3].dstfile.pixelHeight
              : this.allFonts[this.monogramObj.middleChar.fontID].sizes[
          this.monogramObj.middleChar.fontSizeID
        ].DictCharacters[this.char2].dstfile.pixelHeight)) *
          (this.getDpi() / 254.0)) + (parseFloat(this.top ? this.top : 0))
        );
      }
    },
    // getMaxMonogramHeight(monogramStoreObj, numOfCharacters){
    //   return numOfCharacters == "2"
    //     ? Math.max(
    //         this.getMonogramDst(
    //           monogramStoreObj,
    //           this.char1,
    //         'left'
    //         ).pixelHeight,
    //         this.getMonogramDst(
    //           monogramStoreObj,
    //           this.char3,
    //         'right'
    //         ).pixelHeight
    //       )
    //     : Math.max(
    //         this.getMonogramDst(
    //           monogramStoreObj,
    //           this.char1,
    //         'left'
    //         ).pixelHeight,
    //         this.getMonogramDst(
    //           monogramStoreObj,
    //           this.char2,
    //         'middle'
    //         ).pixelHeight,
    //         this.getMonogramDst(
    //           monogramStoreObj,
    //           this.char3,
    //         'right'
    //         ).pixelHeight
    //       );

    // },
    // getMonogramDst(monogramStoreObj, char, typeChar) {  // typeChar= 'left' | 'middle' | 'right'
    //   switch (typeChar) {
    //     case 'left':
    //       // console.log(char);
    //       // console.log(this.allFonts[monogramStoreObj.leftChar.fontID].sizes[
    //       //   monogramStoreObj.leftChar.fontSizeID].DictCharacters[char]);
    //       //   console.log(this.allFonts[monogramStoreObj.leftChar.fontID].sizes[
    //       //   monogramStoreObj.leftChar.fontSizeID].DictCharacters[char].dstfile);
    //       return this.allFonts[monogramStoreObj.leftChar.fontID].sizes[
    //         monogramStoreObj.leftChar.fontSizeID].DictCharacters[char].dstfile
    //     case 'middle':
    //       return this.allFonts[monogramStoreObj.middleChar.fontID].sizes[
    //         monogramStoreObj.middleChar.fontSizeID].DictCharacters[char].dstfile
    //     case 'right':
    //       return this.allFonts[monogramStoreObj.rightChar.fontID].sizes[
    //         monogramStoreObj.rightChar.fontSizeID].DictCharacters[char].dstfile
    //     default:
    //       break;
    //   }
    // },
    getDpi() {
      if(this.dw == undefined || this.dh == undefined) {
        return this.dpi;
      } else {
        var height = this.store.getMaxMonogramHeight(this.monogramObj, this.char1, this.char2, this.char3);
        // var width = 0;
        // width += this.store.getCharWidthFromCharObj(this.monogramObj.leftChar, this.char1);
        // width += this.store.getCharWidthFromCharObj(this.monogramObj.rightChar, this.char3);
        // width += this.monogramObj.distance1;
        // if(this.monogramObj.numOfCharacters == "3") {
        //   width += this.store.getCharWidthFromCharObj(this.monogramObj.rightChar, this.char2);
        //   width += this.monogramObj.distance2;
        // }
        var width = this.store.getMonogramWidth(this.monogramObj, this.char1, this.char2, this.char3, this.distance1, this.distance2);
        var hDpi = this.dh / height;
        var wDpi = this.dw / width;
        if(hDpi < wDpi) {
          return (this.dh / height) * 254.0;
        } else {
          return (this.dw / width) * 254.0;
        }
        //לגמור לחשב את הדיפיאי
        //לבדוק האם הגיע גודל מסוים
        //אם כן לקחת את הדיפיאי אורך או רוחב מה שיצא יותר גדול
        //ולעשות איתו את החישוב שיש למטה
        //את האורך והרוחב ששולחים זה אורך המונוגרם - האות הגבוהה ביותר
        //והרוחב זה כולל רוחב אותיות ורווחים בין האותיות

        // this.dpi =
        //   (150.0 /
        //     this.FontToPopup.sizes[[Object.keys(this.FontToPopup.sizes)[0]]]
        //       .FontHeight) *
        //   254.0

        //charactarObject.charFile.dstfile.pixelWidth * (dpi / 254.0)

      }
    },
    getMonogramBoxSize(){
      var x = 0;
      const old_x = x;
      var height = this.store.getMaxMonogramHeight(this.monogramObj, this.char1, this.char2, this.char3);
      var width = 0;
      x = x + this.store.getCharWidthFromCharObj(this.monogramObj.leftChar, this.char1) + parseFloat(this.distance1);
      if (this.monogramObj.numOfCharacters == "2") {
        width = x + this.store.getCharWidthFromCharObj(this.monogramObj.rightChar, this.char3) - old_x;
      } else if (this.monogramObj.numOfCharacters == "3") {
        x = x + this.store.getCharWidthFromCharObj(this.monogramObj.middleChar, this.char2) + parseFloat(this.distance2);
        width = x + this.store.getCharWidthFromCharObj(this.monogramObj.rightChar, this.char3) - old_x;
      }
      return {width: width, height: height};
      // monogramObj.dragTransform.width = monogramObj.dragSize.w * this.store.currentEditingProps.dpi / 254;
      // monogramObj.dragTransform.height = monogramObj.dragSize.h * this.store.currentEditingProps.dpi / 254;
    }
  },
};
</script>

<style scoped>
.char-container {
  position: relative;
}
.char-layer {
  position: absolute;
  top: 0;
  background-size: contain;
  background-repeat: no-repeat;
}
</style>
